import { useState } from 'react'
import { Helmet } from 'react-helmet'
import { GenericLogFilterForm, GenericLogTable } from 'components/logsGeneric'
import ClearFiltersButton from 'components/common/clearFiltersButton'
import { FILTER_FIELD_GENERIC_LOG } from 'components/logsGeneric/genericLogFilterForm'
import { FilterMeta } from 'utils/helpers'

const GenericLogs = () => {
  const [filterMeta, setFilterMeta] = useState<FilterMeta>()

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Generic Logs</title>
      </Helmet>

      <div className="flex items-center justify-between gap-2">
        <div className="title">Generic Logs</div>
        <ClearFiltersButton filterKey={FILTER_FIELD_GENERIC_LOG} />
      </div>

      <GenericLogFilterForm filterMeta={filterMeta} />
      <GenericLogTable onFilterMeta={setFilterMeta} />
    </>
  )
}

export default GenericLogs
